/* eslint-disable import/no-mutable-exports */

let config = {
  colors: {
    primary: {
      100: '#85a0b9',
      200: '#7090ae',
      300: '#5c80a2',
      400: '#477097',
      500: '#33608b',
      600: '#2e567d',
      700: '#294d6f',
      800: '#244361',
      900: '#1f3a53',
    },
    secondary: {
      100: '#fc9b9f',
      200: '#fc8b8f',
      300: '#fb7a7f',
      400: '#fb6a6f',
      500: '#fa595f',
      600: '#e15056',
      700: '#c8474c',
      800: '#af3e43',
      900: '#963539',
    },
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    gray: {
      100: '#f7fafc',
      200: '#edf2f7',
      300: '#e2e8f0',
      400: '#cbd5e0',
      500: '#a0aec0',
      600: '#718096',
      700: '#4a5568',
      800: '#2d3748',
      900: '#1a202c',
    },
    red: {
      100: '#fff5f5',
      200: '#fed7d7',
      300: '#feb2b2',
      400: '#fc8181',
      500: '#f56565',
      600: '#e53e3e',
      700: '#c53030',
      800: '#9b2c2c',
      900: '#742a2a',
    },
    green: {
      100: '#f0fff4',
      200: '#c6f6d5',
      300: '#9ae6b4',
      400: '#68d391',
      500: '#48bb78',
      600: '#38a169',
      700: '#2f855a',
      800: '#276749',
      900: '#22543d',
    },
  },
};

export default config;

export const setOptions = (options) => { config = options; };